//////// GHG 1.5
const oneFiveSchema = {
  title: "1.5 Direct Emissions from Agricultural Sources",
  addAPI: "cat1_5AddEmissionActivityAPI",
  cat: "cat1_5",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Name / Number",
      resetOnChange: false,
      required: true,
    },
  ],
};

export default oneFiveSchema;
